import React from "react";

function TopCryptoE() {
  return (
    <>
      <div className="testimonial-style-two-area default-padding-top pb-60 pb-xs-70 bg-gray blurry-shape-bottom">
        <div className="container">
          <div className="row">
            <div className="col-lg-8 offset-lg-2">
              <div className="site-heading text-center">
                <h4 className="sub-title">Testimonials</h4>
                <h2 className="title split-text-right split-text-in-right">
                  Top Crypto Exchange We Work With
                </h2>
              </div>
            </div>
          </div>
        </div>
        <div className="container">
          {/* <div className="testimonial-style-two-items text-center fade-up-anim">
            <div className="testimonial-style-two-carousel swiper">
              <div className="swiper-wrapper">
                <div className="">
                  <div className="testimonial-style-two">
                    <div className="item">
                      <div className="content">
                        <p>
                          By leveraging an extensive array of blockchain
                          protocols, development frameworks & advanced design
                          tools, our skilled team at Xeer Technology provides
                          customized NFT game development solutions designed to
                          meet your specific needs!
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div> */}

          <div className="row">
            <div className="col-lg-10 offset-lg-1">
              <div className="testimonial-provider-thumbs transform-up-animation">
                <div className="testimonial-provider-item transform-animation-item">
                  <img
                    src="https://validthemes.net/site-template/robok/assets/img/team/5.jpg"
                    alt="Image Not Found"
                  />
                </div>
                <div className="testimonial-provider-item transform-animation-item">
                  <img
                    src="https://validthemes.net/site-template/robok/assets/img/team/6.jpg"
                    alt="Image Not Found"
                  />
                </div>
                <div className="testimonial-provider-item transform-animation-item">
                  <img
                    src="https://validthemes.net/site-template/robok/assets/img/team/9.jpg"
                    alt="Image Not Found"
                  />
                  <img
                    src="https://validthemes.net/site-template/robok/assets/img/team/2.jpg"
                    alt="Image Not Found"
                  />
                </div>
                <div className="testimonial-provider-item transform-animation-item">
                  <img
                    src="https://validthemes.net/site-template/robok/assets/img/team/3.jpg"
                    alt="Image Not Found"
                  />
                  <img
                    src="https://validthemes.net/site-template/robok/assets/img/team/10.jpg"
                    alt="Image Not Found"
                  />
                </div>
                <div className="testimonial-provider-item transform-animation-item">
                  <img
                    src="https://validthemes.net/site-template/robok/assets/img/team/7.jpg"
                    alt="Image Not Found"
                  />
                </div>
                <div className="testimonial-provider-item transform-animation-item">
                  <img
                    src="https://validthemes.net/site-template/robok/assets/img/team/8.jpg"
                    alt="Image Not Found"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default TopCryptoE;
